import { k as f } from "./utils.mjs";
function p(a) {
  let {
    swiper: e,
    duration: o,
    transformElements: s,
    allSlides: l
  } = a;
  const {
    activeIndex: d
  } = e, c = (n) => n.parentElement ? n.parentElement : e.slides.filter((t) => t.shadowRoot && t.shadowRoot === n.parentNode)[0];
  if (e.params.virtualTranslate && o !== 0) {
    let n = !1, r;
    l ? r = s : r = s.filter((t) => {
      const i = t.classList.contains("swiper-slide-transform") ? c(t) : t;
      return e.getSlideIndex(i) === d;
    }), r.forEach((t) => {
      f(t, () => {
        if (n || !e || e.destroyed)
          return;
        n = !0, e.animating = !1;
        const i = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(i);
      });
    });
  }
}
export {
  p as e
};
//# sourceMappingURL=effect-virtual-transition-end.mjs.map
